import gql from 'graphql-tag';

const disposisiFragment = gql`
  fragment disposisiFragment on Disposisi {
    id
    ke_pengguna
    disposisi_sebelumnya
    keterangan
    created_at
    tipe
    paraf
    pengguna {
      id
      nama
      nip
      jabatan {
        id
        nama
      }
    }
    tujuan_pengguna {
      id
      nama
      nip
      jabatan {
        id
        nama
      }
    }
  }
`;

const POST = gql`
  mutation disposisi($input: Disposisi_CreateInput!) {
    disposisiCreate(input: $input) {
      ...disposisiFragment
    }
  }
  ${disposisiFragment}
`;

export { POST, disposisiFragment };
